module.exports = __webpack_public_path__ + "static/media/instruction-avatar.3224625b.webp";